import { atom, } from 'recoil';

export const VehicleHistoryDateState = atom({
  key: "VehicleHistoryDateState",
  default: null,
});